import { jsx, css } from '@emotion/react';
import { useState } from 'react';

import withDefaultPrevented from '../../withDefaultPrevented';
import Modal from '../Modal';
import Container from '../OC/oc-container';
import Video from '../OC/oc-video.jsx';
import Section from '../OC/sections/oc-section';

const fourUp = css`
  @media (max-width: 767px) {
    .resource {
      margin-bottom: 16px;

      img {
        width: 100%;
      }
    }
  }

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 30px;
    row-gap: 48px;
  }
`;

const GalleryImagesList = ({ images, onImageClick }) => {
  if (!images || !images.length) {
    return null;
  }

  const videoIcon = css`
    display: block;
    position: relative;

    &:before {
      content: '';
      background-image: url(https://imagecdn.owenscorning.com/ocimages/image/upload/v1603896276/insulation/residential/ulf-calculator/icon-video.svg);
      background-repeat: no-repeat;
      width: 24px;
      height: 16px;
      display: inline-block;
      position: absolute;
      top: 24px;
      left: 20px;
    }
  `;

  const videoContainer = css`
    padding: 50px 17px 32px;
  `;

  const videoH3 = css`
    margin: 0 17px 32px;
  `;

  const toImageItem = (img, idx) => {
    const [modalOpen, changeModalState] = useState(false);

    return (
      <div className="resource" key={idx}>
        <a
          href="#"
          className={img.youtube_id ? 'video' : 'image'}
          css={videoIcon}
          onClick={withDefaultPrevented(() => changeModalState(true))}
          data-track="learn-more"
          data-track-destination={img.name}
          title={img.name}
        >
          <img src={img.img_url} alt={img.name} className="img-responsive" />
        </a>
        <h4>{img.name}</h4>

        <Modal
          open={modalOpen}
          onClose={() => {
            changeModalState(false);
          }}
        >
          <Video css={videoContainer} src={img.youtube_id} />
          <h3 css={videoH3}>{img.name}</h3>
        </Modal>
      </div>
    );
  };

  return <>{images.map(toImageItem)}</>;
};

const videos = {
  gallery_images: [
    {
      img_url:
        'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto/v1603817485/insulation/residential/ulf-calculator/video-1.jpg',
      name: 'Why this Insulation Pro Insists on Fiberglass vs. Cellulose for Best Results',
      youtube_id: 'va7dlqjzBH8',
    },
    {
      img_url:
        'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto/v1603817485/insulation/residential/ulf-calculator/video-2.jpg',
      name: 'Product Focus: PROPINK® L77 PINK® Fiberglas™ Loosefill Insulation',
      youtube_id: 'u48lVmEwnCU',
    },
    {
      img_url:
        'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto/v1603817485/insulation/residential/ulf-calculator/video-3.jpg',
      name: 'Unbonded Loosefill Blowing Machine Theory',
      youtube_id: 'mx0IBTgCZsM',
    },
    {
      img_url:
        'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto/v1603817485/insulation/residential/ulf-calculator/video-4.jpg',
      name: 'ULF Blowing Machine Troubleshooting Tips',
      youtube_id: 'HqiJfoLUQRU',
    },
    {
      img_url:
        'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto/v1603817485/insulation/residential/ulf-calculator/video-6.jpg',
      name: 'Product Focus: PROPINK Complete™ Blown-in Wall System',
      youtube_id: 'eyj1EcPlqhA',
    },
  ],
};

const GalleryModalMedia = ({ image }) => {
  if (!image) return null;
  if (image.youtube_id) return <Video src={image.youtube_id} />;
  return <img src={image.img_url} alt={image.name} />;
};

const GalleryModal = ({ image, onClose }) => {
  const className = `no-borders zoom-modal gallery-preview-modal ${
    image && image.youtube_id ? 'video-modal' : 'image-modal'
  }`;

  return (
    <Modal name="Gallery Image Preview" open={image} onClose={onClose} className={className}>
      <GalleryModalMedia image={image} />

      <h3 className="image-name">{image && image.name}</h3>
    </Modal>
  );
};

const Gallery = ({ videos, onImageClick }) => (
  <Section anchor="gallery" css={fourUp}>
    <GalleryImagesList images={videos.gallery_images} onImageClick={onImageClick} />
  </Section>
);

const TrainingVideos = () => (
  <Container maxWidth="1170">
    <Section anchor="videos">
      <h2>Insulation Training Videos</h2>

      <Gallery
        videos={videos}
        onImageClick={() => {
          changeModalState(true);
        }}
      />
    </Section>
  </Container>
);

export default TrainingVideos;
